import { __spreadArrays } from "tslib";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingIndicator from '../../../LoadingIndicator';
import StreamedList from '../../../StreamedList';
import { FolderType } from '../../redux/types';
import GallectionListItem from '../../../GallectionListItem';
import TextButton from '../../../Buttons/TextButton';
import Input from '../../../Input';
import SearchIcon from '../../../Icons/24x24/Search';
import { BiEventType } from '../../../biLogger/constants';
import { useBiClickLogger } from '../../../biLogger/hooks/useBiClickLogger';
import s from './FolderList.scss';
var FolderList = function (_a) {
    var submissionType = _a.submissionType, folders = _a.folders, isFetching = _a.isFetching, streamId = _a.streamId, hasOnlyOneChunkOfGroupFoldersToLoad = _a.hasOnlyOneChunkOfGroupFoldersToLoad, onFolderSelected = _a.onFolderSelected;
    var t = useTranslation().t;
    var _b = useState(''), filterValue = _b[0], setFilterValue = _b[1];
    var hasNoFolders = !isFetching && !folders.length;
    var _c = useState([]), justAddedToFolderIds = _c[0], setAddedToFolderIds = _c[1];
    var onGallectionListItemChange = function (_a) {
        var folderId = _a.folderId, isSelected = _a.isSelected;
        if (isSelected) {
            onFolderSelected(folderId);
            setAddedToFolderIds(__spreadArrays(justAddedToFolderIds, [folderId]));
        }
    };
    var onFilterInputChange = function (value) { return setFilterValue(value); };
    var setInputRef = useBiClickLogger({
        evid: BiEventType.DEFAULT,
        click_info: submissionType === FolderType.Collection
            ? 'addToGroup.searchCollection'
            : 'addToGroup.searchGallery',
    }).setTrackingRef;
    return (React.createElement(React.Fragment, null,
        hasOnlyOneChunkOfGroupFoldersToLoad && (React.createElement(Input, { refInput: setInputRef, value: filterValue, className: s['filter-input'], onChange: onFilterInputChange, placeholder: t('addToGroupPopup.input.filter.placeholder'), withFilledBackground: true, prefixIcon: SearchIcon })),
        React.createElement(StreamedList, { streamId: streamId, className: s['list'], wrapperClassName: s['scrollable'] },
            folders.map(function (_a) {
                var folder = _a.folder, added = _a.added, suggested = _a.suggested;
                if (!folder ||
                    (filterValue &&
                        !folder.name.toLowerCase().includes(filterValue.toLowerCase()))) {
                    return null;
                }
                var renderSuffix = function () {
                    var buttonI18nKey = 'addToGroupPopup.button.add';
                    if (added) {
                        buttonI18nKey = 'addToGroupPopup.button.added';
                    }
                    if (suggested) {
                        buttonI18nKey = 'addToGroupPopup.button.suggested';
                    }
                    return (React.createElement(TextButton, { size: "small", variant: "approval-green", disabled: added || suggested }, t(buttonI18nKey)));
                };
                return (React.createElement(GallectionListItem, { key: folder.folderId, isSelected: added ||
                        suggested ||
                        justAddedToFolderIds.includes(folder.folderId), isDisabled: added || suggested, gallection: folder, showSuffixOnlyOnHover: !added && !suggested, suffix: renderSuffix(), onChange: onGallectionListItemChange }));
            }),
            hasNoFolders && (React.createElement("div", { className: s['empty'] }, t("addToGroup.noFolders." + submissionType)))),
        isFetching && React.createElement(LoadingIndicator, { view: "llama", className: s['loader'] })));
};
FolderList.displayName = 'FolderList';
export default FolderList;
//# sourceMappingURL=FolderList.js.map